import React, { useState, useEffect } from "react";
import {
    Box,
    Flex,
    Progress,
    Text,
    Link,
    IconButton,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import { keyframes } from "@chakra-ui/react";

export function LoadingIndicator({
                                     socket,
                                     onCancel,              // called when user clicks the stop button
                                 }) {
    const [current, setCurrent] = useState(0);
    const [total, setTotal] = useState(0);
    const [title, setTitle] = useState("Loading...");
    const [subtitle, setSubtitle] = useState("");

    useEffect(() => {
        const handler = ({ progress }) => {
            // pull out the three bits you need
            const {
                current_progress: current,
                total_documents: total,
                document_just_finished: docName,
            } = progress;

            // update your state
            setCurrent(current);
            setTotal(total);
            setTitle(`Processing ${docName}`);

            // guard against div by zero, then format a nice "XX% completed"
            const percent = total > 0
                ? Math.round((current / total) * 100)
                : 0;

            setSubtitle(`${percent}% done`);
        };

        socket.on("query_independent_on_n_docs", handler);
        return () => {
            socket.off("query_independent_on_n_docs", handler);
        };
    }, [socket]);


    const percent = total > 0 ? (current / total) * 100 : 0;

    // define the keyframes for the shimmer
    const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

// your shimmering style
    const shimmerStyle = {
        bgGradient: "linear(to-r, rgba(255,255,255,0.6), rgba(255,255,255,0.99), rgba(255,255,255,0.6))",
        bgSize: "200% 100%",
        bgClip: "text",
        animation: `${shimmer} 2.5s ease-in-out infinite`,
    };

    return (
        <Flex
            align="center"
            bg="gray.800"
            ml={3}
            px={6}
            py={5}
            mt={8}
            mb={9}
            borderRadius="lg"
            maxW="600px"
            w="100%"
        >
            <Box flex="1" mr={3}>
                <Flex justify="space-between" align="baseline">
                    <Text
                        as="span"
                        fontSize="sm"
                        fontWeight="medium"
                        sx={shimmerStyle}
                    >
                        {title}
                    </Text>

                    {subtitle && (
                        <Link fontSize="xs" color="blue.200" href="#">
                            {subtitle}
                        </Link>
                    )}
                </Flex>

                <Flex align="center" mt={4}>
                    <Progress
                        value={percent}
                        size="sm"
                        flex="1"
                        borderRadius="full"
                        bg="gray.600"
                        colorScheme="blue"
                    />
                    <Text fontSize="xs" color="white" ml={3}>
                        {current}/{total} docs processed
                    </Text>
                </Flex>
            </Box>

            {/*{onCancel && (*/}
            {/*    <IconButton*/}
            {/*        aria-label="Stop loading"*/}
            {/*        icon={<CloseIcon />}*/}
            {/*        size="sm"*/}
            {/*        onClick={onCancel}*/}
            {/*        color="white"*/}
            {/*        bg="gray.600"*/}
            {/*        _hover={{ bg: "gray.500" }}*/}
            {/*    />*/}
            {/*)}*/}
        </Flex>
    );
}
